import { client } from "@/shared/api/client";
import { unwrap, type Envelope } from "@/shared/api/envelope";
import type { OrgSummary } from "@/shared/types";

// No org id anywhere: the org is derived from the token (README.md#use-the-api).

/** Rename the caller's org. The backend re-slugifies from the new name. */
export async function patchOrg(body: { name: string }): Promise<OrgSummary> {
  return unwrap(await client.patch<Envelope<OrgSummary>>("/orgs", body));
}

/** Only reachable when the caller has no org at all — they become its owner. */
export async function createOrg(body: { name: string }): Promise<OrgSummary> {
  return unwrap(await client.post<Envelope<OrgSummary>>("/orgs", body));
}
